import { Icon, IconButton, IIconStyles } from '@fluentui/react';
import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    /* margin-right: var(--space-sm); */
`;

export const StIcon = styled(Icon)`
    color: var(--color-secondary-darker);
    margin-left: 5px;
    :hover {
        color: var(--color-primary);
    }
`;
